import m from 'mithril'
import type { Restaurant, Review } from '../../shared/types.ts'
import { api } from '../api.ts'
import { Empty, ErrorNote, Spinner } from '../ui.ts'
import { PlaceCard } from './PlaceCard.ts'
import { ReviewCard } from './ReviewCard.ts'

type Payload = { restaurant: Restaurant; reviews: Review[] }

/** A restaurant's permanent page, /r/n931799207: the place card, then everyone's reviews. */
export const RestaurantView: m.ClosureComponent<{ ref: string }> = (vnode) => {
  const ref = vnode.attrs.ref
  let data: Payload | null = null
  let error = ''

  const load = async () => {
    try {
      data = await api<Payload>(`/api/restaurants/${ref}`)
      document.title = `${data.restaurant.name} · Food Tracker`
    } catch (err) {
      error = (err as Error).message
    }
    m.redraw()
  }

  return {
    oninit: load,
    onremove: () => {
      document.title = 'Food Tracker'
    },
    view: () => {
      if (error && !data) return m(ErrorNote, { text: error })
      if (!data) return m(Spinner)

      return m('section.stack', [
        m(PlaceCard, { place: data.restaurant, onreview: load }),
        m('h2.section-title', 'Reviews'),
        data.reviews.length
          ? m('div.stack', data.reviews.map((review) => m(ReviewCard, { key: review.id, review, hidePlace: true })))
          : m(Empty, { text: 'No reviews yet' }),
      ])
    },
  }
}
